import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';
import { VisitTotalProductsUsedModel } from '../../visit-day-details.service';
import {
  ProductUsageDetailsDialogComponent,
  ProductUsageDetailsDialogData,
} from '../product-usage-details-dialog/product-usage-details-dialog.component';

@Component({
  selector: 'app-visit-detail-products-usage',
  templateUrl: './visit-detail-products-usage.component.html',
  styleUrls: ['./visit-detail-products-usage.component.scss'],
})
export class VisitDetailProductsUsageComponent extends BaseAccordionComponent {
  @Input() productsUsage: VisitTotalProductsUsedModel[] = [];

  constructor(accordionService: AccordionService, private dialog: MatDialog) {
    super(accordionService);
  }

  public openProductUsageDetails(product: VisitTotalProductsUsedModel): void {
    const dialogData: ProductUsageDetailsDialogData = {
      productName: product.name || '',
      details: product.details || [],
    };

    this.dialog.open(ProductUsageDetailsDialogComponent, {
      data: dialogData,
      autoFocus: false,
      restoreFocus: false,
    });
  }
}
